import angular from 'angular'

import { last, slice, isArray, isFunction } from 'lodash-es'

import exth from '../utils/exth'

const ngFunc = (ngFunc) => isArray(ngFunc) ? last(ngFunc) : ngFunc

angular
  .module('ggs')
  .config(($compileProvider, $rootElementProvider) => {
    const extras = exth.getExtraComponents($rootElementProvider.$get())
    extras.forEach((extra) => {
      $compileProvider.component(extra.cmpName, {
        template: extra.template,
        bindings: extra.bindings,
        controller: extra.controller
      })
    })
  })
  .config(($provide, $injector, $rootElementProvider) => {
    const replacers = exth.getComponentReplacers($rootElementProvider.$get())
    replacers.forEach((replacer) => {
      $provide.decorator(replacer.dirName, decorator)

      function decorator($delegate) {
        'ngInject'

        // replace
        const orig = $delegate[0]
        orig.template = replacer.template
        orig.controller = ngFunc(replacer.controller)
        orig.controller.$inject = $injector.annotate(replacer.controller)
        return $delegate
      }
    })
  })
  .config(($provide, $injector, $rootElementProvider) => {
    const patches = exth.getComponentPatches($rootElementProvider.$get())
    patches.forEach((patch) => {
      $provide.decorator(patch.dirName, decorator)

      function decorator($delegate) {
        'ngInject'

        // template
        const orig = $delegate[0]
        orig.template = isFunction(patch.template)
          ? patch.template(orig.template)
          : patch.template.replace(patch.origPlh, orig.template)
        // inject
        const patchInject = $injector.annotate(patch.controller)
        const origInject = $injector.annotate(orig.controller)
        const sumInject = patchInject.concat(origInject)
        // controller
        const patchController = ngFunc(patch.controller)
        const origController = ngFunc(orig.controller)
        const sumController = function() {
          const patchDeps = slice(arguments, 0, patchInject.length)
          const origDeps = slice(arguments, patchInject.length)
          patchController.apply(this, patchDeps)
          origController.apply(this, origDeps)
        }
        orig.controller = sumController
        orig.controller.$inject = sumInject
        // done
        return $delegate
      }
    })
  })
  .config(($provide, $injector, $rootElementProvider) => {
    const patches = exth.getServicePatches($rootElementProvider.$get())
    patches.forEach((patch) => {
      const patchDecorator = ngFunc(patch.decorator)
      const patchDecInject = $injector.annotate(patch.decorator)

      const proxyDecorator = ngFunc(decorator)
      const proxyDecInject = $injector.annotate(decorator)

      proxyDecorator.$inject = proxyDecInject.concat(patchDecInject)
      $provide.decorator(patch.serviceName, proxyDecorator)

      function decorator() {
        'ngInject'

        const patchDeps = slice(arguments, proxyDecInject.length)
        const patchResp = patchDecorator.apply(null, patchDeps)
        return patchResp
      }
    })
  })
